<div class="negative-margin mr-2 pb-3 border-left">
    <div *ngIf="toggle"
        (click)="toggleSidebar()"
        kui-list-item
        kui-action
        class="close-button border-bottom overflow-hidden">
        <kui-icon name="chevron-left"></kui-icon>
    </div>

    <ng-container *ngIf="isOpen">


        <div class="border-bottom mt-3"
            *ngIf="linkExpired">

            <div class="asset-item">
                <div class="asset-item__icon">
                    <kui-icon [name]="'exclamation-triangle'"
                        size="sm"></kui-icon>
                </div>
                <div class="asset-item__text flex-1">
                    <strong>{{ 'STATUS.DETAILS.ASSET_LINKAGE.TITLE' | translate }}</strong>
                    <p class="mb-0">{{ 'STATUS.DETAILS.ASSET_LINKAGE.EXPIRED' | translate }}</p>
                </div>
            </div>

        </div>

        <div class="border-bottom mt-3"
            *ngIf="geoLock">

            <div kui-action
                class="asset-item"
                (click)="userAction.emit('geolock.zoom')">
                <div class="asset-item__icon"
                    [class.warning]="geoLockViolated">
                    <kui-icon [name]="'lock'"
                        size="sm"></kui-icon>
                </div>
                <div *ngIf="!geoLockViolated"
                    class="asset-item__text flex-1">
                    <strong>{{ 'STATUS.DETAILS.GEO_LOCK.LOCKED' | translate }}</strong>
                    <p class="mb-0"
                        *ngIf="geoLock.user">{{ geoLock.start | timeAgo}} {{ 'STATUS.DETAILS.GEO_LOCK.LOCKED_BY' | translate:{ name: geoLock.user.name } }}</p>
                </div>
                <div *ngIf="geoLockViolated"
                    class="asset-item__text flex-1">
                    <strong>{{ 'STATUS.DETAILS.GEO_LOCK.VIOLATED' | translate }}</strong>
                    <p class="mb-0">{{ 'STATUS.DETAILS.GEO_LOCK.VIOLATED_DESC' | translate }}</p>
                </div>
                <div class="asset-item__action pl-3">
                    <button kui-button
                        color="primary"
                        (click)="userAction.emit('geolock.clear')">
                        <kui-icon name="lock-open"></kui-icon>
                    </button> </div>
            </div>

        </div>

        <div class="border-bottom mt-3"
            *ngIf="geoLockProfile && geoLockEngaged">

            <div class="asset-item">
                <div class="asset-item__icon"
                    [class.warning]="geoLockViolated">
                    <kui-icon [name]="'lock'"
                        size="sm"></kui-icon>
                </div>
                <div *ngIf="!geoLockViolated"
                    class="asset-item__text flex-1">
                    <strong>{{ 'STATUS.DETAILS.GEO_LOCK.LOCKED' | translate }}</strong>
                    <p class="mb-0">{{ 'STATUS.DETAILS.GEO_LOCK.LOCKED_BY_PROFILE' | translate:{ name: geoLockProfile.name } }}</p>
                </div>
                <div *ngIf="geoLockViolated"
                    class="asset-item__text flex-1">
                    <strong>{{ 'STATUS.DETAILS.GEO_LOCK.VIOLATED' | translate }}</strong>
                    <p class="mb-0">{{ 'STATUS.DETAILS.GEO_LOCK.VIOLATED_PROFILE_DESC' | translate:{ name: geoLockProfile.name } }}</p>
                </div>

            </div>

        </div>

        <div class="border-bottom mt-3"
            *ngFor="let task of tasks">

            <div kui-action
                class="asset-item">
                <div class="asset-item__icon">
                    <kui-icon *ngIf="task.active"
                        [name]="'play'"
                        size="sm"></kui-icon>
                    <kui-icon *ngIf="!task.active"
                        [name]="task.task.state == 'success' ? 'check' : 'exclamation-circle'"
                        size="sm"></kui-icon>
                </div>
                <div class="asset-item__text flex-1">
                    <strong>{{ task.title }}</strong>
                    <p class="mb-0"
                        *ngIf="task.active">{{ task.description }}</p>
                    <p class="mb-0 pt-1 muted">{{ task.state }}<span *ngIf="task.error"> - {{ task.error }}</span></p>
                </div>
                <div class="asset-item__action pl-3"
                    *ngIf="task.active">
                    <button kui-button
                        color="none"
                        (click)="userAction.emit('task.cancel.' + task.id)">
                        <kui-icon name="times"></kui-icon>
                    </button> </div>
            </div>

        </div>

        <ng-container *ngIf="contacts && contacts.length">

            <div class="w-100">
                <key-contacts [contacts]="contacts"
                    [compact]="true"></key-contacts>
            </div>

        </ng-container>

        <div class="border-bottom mt-3"
            *ngIf="linkedAssets && linkedAssets.length">

            <div kui-action
                class="asset-item"
                *ngFor="let asset of linkedAssets"
                (click)="navigateToAsset(asset.id)">
                <div class="asset-item__icon">
                    <kui-icon [name]="asset.icon?.name"
                        [ngStyle]="getIconStyles(asset.icon?.color)"
                        size="sm"></kui-icon>
                </div>
                <div class="asset-item__text">
                    <strong>{{asset.name}}</strong>
                    <p class="mb-0">{{asset.type}}</p>
                </div>
            </div>

        </div>

        <ng-container *ngIf="state && state.length">

            <div class="nav-title w-100">
                <h6 class="muted">{{ 'STATUS.DETAILS.SIDEBAR.HEADER.STATE' | translate }}</h6>
            </div>

            <div kui-list-item
                class="list-item  align-items-center"
                *ngFor="let item of state">
                <p kui-list-item-text
                    class="mb-0">
                    <strong>{{ item.name }}</strong>
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    <kui-icon name="tag"
                        size="sm"
                        [ngStyle]="{ color: item.color }"></kui-icon>
                    {{ item.value }}
                </p>
            </div>

        </ng-container>

        <ng-container *ngIf="ioValues && ioValues.length">

            <div class="nav-title w-100">
                <h6 class="muted">{{ 'STATUS.DETAILS.SIDEBAR.HEADER.IO' | translate }}</h6>
            </div>

            <div kui-list-item
                class="list-item"
                *ngFor="let io of ioValues">
                <p kui-list-item-text
                    class="mb-0">
                    <strong>{{ io.title }}</strong>
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    <span *ngIf="io.tasks.length === 0">
                        <span *ngIf="!io.actions || io.actions.length === 0"
                            [innerHtml]="io.value"></span>
                        <span *ngIf="io.actions && io.actions.length > 0">
                            <kui-dropdown [style]="'none'"
                                [menu]="io.actions"><a>{{ io.value }}</a></kui-dropdown>
                        </span>
                    </span>
                    <span *ngIf="io.tasks.length > 0">
                        <kui-loader size="small"></kui-loader>
                    </span>
                </p>
            </div>
        </ng-container>

        <ng-container *ngIf="fields && fields.length">

            <div class="nav-title w-100">
                <h6 class="muted">{{ 'STATUS.DETAILS.SIDEBAR.HEADER.INFO' | translate }}</h6>
            </div>

            <div kui-list-item
                class="list-item"
                *ngFor="let field of fields">
                <p kui-list-item-text
                    class="mb-0">
                    <strong>{{ field.name }}</strong>
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    {{ field.value }}
                </p>
            </div>

        </ng-container>

        <ng-container *ngIf="telemetry">

            <div class="nav-title w-100">
                <h6 class="muted">{{ 'STATUS.DETAILS.SIDEBAR.HEADER.TELEMETRY' | translate }}</h6>
            </div>

            <div kui-list-item
                class="list-item"
                *ngFor="let item of telemetryItems">
                <p kui-list-item-text
                    class="mb-0">
                    <strong>{{ item.name }}</strong>
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    {{ item.value }}
                </p>
            </div>

            <div kui-list-item
                class="list-item w-100"
                *ngIf="!showAllTelemetry">
                <p kui-list-item-text
                    class="mb-0">
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    <a (click)="buildTelemetry(true)"
                        kui-action
                        class="text-link">{{ 'STATUS.DETAILS.SIDEBAR.TELEMETRY.SHOW_MORE' | translate }}</a>
                </p>
            </div>

            <div kui-list-item
                class="list-item w-100"
                *ngIf="showRawTelemetry">
                <p kui-list-item-text
                    class="mb-0">
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    <a (click)="openRawTelemetry()"
                        kui-action
                        class="text-link">View Raw Telemetry</a>
                </p>
            </div>

        </ng-container>

        <ng-container *ngIf="shares && shares.length">

            <div class="nav-title w-100">
                <h6 class="muted">{{ 'STATUS.DETAILS.SIDEBAR.HEADER.SHARES' | translate }}</h6>
            </div>

            <div kui-list-item
                isActiveOnHover="true"
                class="list-item pointer"
                (click)="userAction.emit('share.edit.' + share.token)"
                *ngFor="let share of shares">
                <p kui-list-item-text
                    class="mb-0">
                    <strong>{{ share.name }}</strong>
                </p>
                <p kui-list-item-text
                    class="ml-auto mb-0">
                    {{ 'SHARED.EXPIRES' | translate }} {{ share.expiry | timeAgo }}
                </p>
            </div>

        </ng-container>

    </ng-container>
</div>